import React from 'react';
import { useState, useEffect,useMemo } from "react";
import { createPortal } from 'react-dom';
import Swal from "sweetalert2";
import { Row, Col, Button } from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { moment } from 'moment';
import { useLocation, Link, useSearchParams } from 'react-router-dom';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { createCheckIn,getCheckInNumber,getDivertWorkSchedules } from '../../services/CheckInServices';
import { getUserAllowedPlants } from '../../services/PlantServices';
import{getAllDeliveryChallanForCheckIn, getDeliveryChallanNumber, getDeliveryChallanDetails} from '../../services/DeliveryChallanServices';
import { getPendingCheckInCount, getPendingCheckInList, getCheckOutDetails } from '../../services/CheckOutServices';
import { getCustomerMainDetails } from '../../services/CustomerMainServices';
import { getCustomerSiteDetails } from '../../services/CustomerSiteServices';
import { showBillingPop, showCustomerSitePop, showDeliveryChallanPop, mapCheckoutToTableRow, PENDING_CHECKIN_LIST_COLUMNS, computeAcceptedQtyFromDc, toQtyNumber, goToCheckInMainForm } from './CheckInUtils';
import SummaryIcon from '../../components/SummaryIcon';
import QuestionIcon from '../../components/QuestionIcon';
import { getDisplayDate } from '../../utils/DateUtils';
import { getCurrentDate, getCurrentTime, formatDateForApi} from '../../utils/DateUtils';
import NumberSetting from '../../components/NumberSetting';
import { AccessAlarm } from '@mui/icons-material';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import ViewOnlyTextbox from '../../components/ViewOnlyTextbox';
import ReactTablePopUpSubmitWrapper from "../../components/ReactTablePopUpSubmitWrapper";
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { GradientCard } from '../../components/ListPageGradientSummary';
import { buildGradientCard } from '../../utils/listSummaryUtils';
import { getReturnPath, navigateAfterFormSave } from '../../utils/returnNavigation';
import PendingCheckInListModal from '../dispatch/PendingCheckInListModal';

function CheckIn() {
  const [cookies] = useCookies(['myToken']);
  const [category] = useCookies(['myCategory']);
  const [superuser] = useCookies(['mySuperuser']);
  const [inputs, setInputs] = useState({});
  const [inProgress, setInProgress] = useState(false);
  const [plant, setPlant] = React.useState([]);
  const [plants,setPlants] =React.useState([]);
  const [deliverychallans,setDeliverychallans] =React.useState([]);
  const [checkouts,setCheckouts] =React.useState([]);
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [error, setError] = useState({});
  const [allcheckout,setAllCheckOut]=React.useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [alldeliverychallan,setAllDeliveryChallan]=React.useState([]);
  const [deliverychallan,setDeliveryChallan]=React.useState([]);
  const[selectedcheckout,setSelectedDC] = useState({});
  const [isLoading, setIsLoading] = useState(false); 
  const [selected_checkout,setSelectedCheckout] = useState({});
  const[selectedWorkSchedule,setSelectedWorkSchedule] = useState({});
  const[balancestatus,setBalanceStatus]= useState([]);
  const[dcstatus,setDcStatus]= useState([]);
  const[divertSchedules,setDivertSchedules]= useState([]);
  const RETURN_BALANCE_OPTIONS = [
    { value: "", label: "choose balance status" },
    { value: "full", label: "Full" },
    { value: "returned", label: "Returned" },
    { value: "wastage", label: "Wastage" },
    { value: "transfer", label: "Divert"},
    { value: "shortage", label: "Shortage"}
  ];
  const ACCEPT_WITH_RETURN_OPTIONS = [
    { value: "nill", label: "Nill" },
    { value: "returned", label: "Returned (site return)" },
    { value: "wastage", label: "Wastage" },
    { value: "transfer", label: "Divert"},
  ];
  const needsReturnQty = (status) => ['returned', 'wastage', 'transfer'].includes(status);
  const needsDivert = (status) => status === 'transfer';

  const loadDivertBatchNo = (plantId) => {
    const resolvedPlantId = plantId
      || selected_checkout?.delivery_challan?.work_schedule?.plant?.id
      || inputs.plant_id;
    if (!resolvedPlantId) {
      return;
    }
    const dcDate = formatDateForApi(inputs.checkin_date || getCurrentDate());
    getDeliveryChallanNumber(cookies, resolvedPlantId, dcDate)
      .then((res) => {
        if (res?.batch_no) {
          setInputs((values) => ({
            ...values,
            batch_no: values.batch_no || res.batch_no,
          }));
        }
      })
      .catch(() => {});
  };

  const loadDivertSchedules = (plantId, notifyIfEmpty = false) => {
    const resolvedPlantId = plantId || inputs.plant_id;
    if (!resolvedPlantId) {
      setDivertSchedules([]);
      return;
    }
    const checkinDate = formatDateForApi(inputs.checkin_date || getCurrentDate());
    getDivertWorkSchedules(cookies, resolvedPlantId, checkinDate)
      .then((res) => {
        const list = (res.work_schedule_list || []).map((ws) => ({
          value: ws.id,
          label: `${ws.schedule_no} | ${ws.grade?.name || ''} | Bal ${ws.balance_qty} | ${ws.consignee || ''}`,
          balance_qty: ws.balance_qty,
        }));
        setDivertSchedules(list);
        if (notifyIfEmpty) {
          if (!list.length && res.message) {
            Swal.fire(res.message, '', 'info');
          } else if (!list.length) {
            Swal.fire('No open Work Schedule found at this plant for divert.', '', 'info');
          }
        }
      })
      .catch((error) => {
        setDivertSchedules([]);
        displayError(error?.response?.data, 'Failed to load work schedules');
      });
  };

  React.useEffect(() => {
    if (needsDivert(inputs.balance_status)) {
      loadDivertSchedules(
        selected_checkout?.delivery_challan?.work_schedule?.plant?.id
      );
    }
  }, [
    selected_checkout?.id,
    inputs.balance_status,
    inputs.plant_id,
    inputs.checkin_date,
  ]);
  const initial_table_data = {
    total_pages: 0,
    records: [],
  };
  const [data, setData] = useState(initial_table_data);
  const [showModal, setShowModal] = useState(false);
  const [showWeighmentModal, setShowWeighmentModal] = useState(false);
  const [showPendingCheckInList, setShowPendingCheckInList] = useState(false);

  React.useEffect(() => {
    setInputs(values => ({...values,
        ['checkin_date']: getCurrentDate(),
        ['checkin_time']: getCurrentTime(),
        // ['weighment_slip_date']: getCurrentDate(),
        // ['weighment_slip_time']: getCurrentTime(),
        // ['checkout_date']: getCurrentDate(),
    }))
  }, []);

  const applyCheckoutList = (checkoutList) => {
    const list = checkoutList?.checkout_list || [];
    setCheckouts(list.map((checkout) => ({ value: checkout.id, label: checkout.checkout_no })));
    setAllCheckOut(list);
    setData({ records: list.map((row) => (row.delivery_challan ? mapCheckoutToTableRow(row) : row)) });
  };

  const refreshPendingCount = (plantId) => {
    getPendingCheckInCount(cookies, plantId)
      .then((result) => {
        setPendingCount(Number(result?.count) || 0);
      })
      .catch(() => {
        setPendingCount(0);
      });
  };

  const loadPendingCheckouts = (plantId) => {
    if (!plantId) {
      applyCheckoutList({ checkout_list: [] });
      setIsLoading(false);
      refreshPendingCount();
      return Promise.resolve();
    }
    setIsLoading(true);
    return getPendingCheckInList(cookies, plantId)
      .then((checkoutList) => {
        applyCheckoutList(checkoutList);
        setPendingCount((checkoutList?.checkout_list || []).length);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error?.response?.data);
        displayError(error?.response?.data ?? error?.message, " Failed");
      });
  };

  React.useEffect(() => {
    getUserAllowedPlants(cookies)
    .then (
        plantList => {
          console.log(JSON.stringify(plantList)+"plantList")
            const plant = plantList.plant_list.filter(obj => obj.status).map(
                plant => {
                    return { value: plant.id, label: plant.plant_alias }
                }
            );
            setPlants(plant);
        }
    )
  }, []);

  React.useEffect(() => {
    refreshPendingCount();
  }, []);
      
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const returnTo = getReturnPath(location, searchParams);
  const returnToDeliveryChallan = Boolean(returnTo && returnTo.includes('DeliveryChallan'));

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === 'tare_weight' || name === 'gross_weight') {
      var tare_weight = document.getElementById('tare_weight').value;
      var gross_weight = document.getElementById('gross_weight').value;     
      if((tare_weight === '') || (tare_weight === NaN) ){
          tare_weight = 0;
      }
      if((gross_weight === '') || (gross_weight === NaN) ){
          gross_weight = 0;
      }
      console.log(tare_weight+"tare_weight")
      console.log(gross_weight+"gross_weight")
      var net_weight = parseFloat(gross_weight) - parseFloat(tare_weight);
      console.log(net_weight+"net_weight")
      setInputs(values => ({...values, ['net_weight']: net_weight})) 
    }
    if (name === 'balance_status') {
      const dcQty = parseFloat(document.getElementById('dc_qty')?.value || selected_checkout?.delivery_challan?.dc_qty || 0);
      const balanceQty = parseFloat(inputs.balance_qty || 0);
      const defaultRet = balanceQty > 0 ? balanceQty : dcQty;
      if (needsReturnQty(value)) {
        setInputs(values => ({
          ...values,
          [name]: value,
          ret_qty: values.ret_qty > 0 ? values.ret_qty : defaultRet,
          other_qty: value === 'transfer' ? (values.other_qty || 0) : 0,
          divert_to_ws: value === 'transfer' ? (values.divert_to_ws || '') : '',
          batch_no: value === 'transfer' ? (values.batch_no || '') : '',
        }));
        if (value === 'transfer') {
          loadDivertSchedules(
            selected_checkout?.delivery_challan?.work_schedule?.plant?.id
          );
          loadDivertBatchNo(
            selected_checkout?.delivery_challan?.work_schedule?.plant?.id
          );
        }
        return;
      }
      setInputs(values => ({
        ...values,
        [name]: value,
        ret_qty: 0,
        other_qty: 0,
        divert_to_ws: '',
        batch_no: '',
      }));
      return;
    }
    setInputs(values => ({...values, [name]:value}));
  }
  
  const handleChangePlant = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    try{
      setInputs(values => ({...values, [name]: value}));
      setSelectedCheckout(values => ({['delivery_challan']:{}}));
      if(name === 'plant_id' && value){
        loadPendingCheckouts(value);
      }
      else
      {
        setInputs({})
        applyCheckoutList({ checkout_list: [] });
        refreshPendingCount();
      }
      }
    catch (e) {
      displayErrorToast(e);
    }
  }

  const handleChangeOpeningKmDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if ( name === 'ending_km') {
         var opening_km = document.getElementById('opening_km').value;
         var ending_km = document.getElementById('ending_km').value;
         document.getElementById('ending_km').setAttribute('min',opening_km);      
         if((opening_km === '') || (opening_km === NaN) ){
          opening_km = 0;
         }
         if((ending_km === '') || (ending_km === NaN) ){
          ending_km = 0;
         }
         console.log(opening_km+"opening_km")
         console.log(ending_km+"ending_km")
        var total_km = parseInt(ending_km) - parseInt(opening_km);
        console.log(total_km+"total_km")
        setInputs(values => ({...values, ['total_km']: total_km})) 
    }
    setInputs(values => ({...values, [name]: event.target.value}))
  };
  const handleChangeOpeningHmDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if ( name === 'ending_hm') {
         var opening_hm = document.getElementById('opening_hm').value;
        var ending_hm = document.getElementById('ending_hm').value;
        document.getElementById('ending_hm').setAttribute('min',opening_hm);     
         if((opening_hm === '') || (opening_hm === NaN) ){
          opening_hm = 0;
         }
         if((ending_hm === '') || (ending_hm === NaN) ){
          ending_hm = 0;
         }
         console.log(opening_hm+"opening_hm")
         console.log(ending_hm+"ending_hm")
        var total_hm = parseInt(ending_hm) - parseInt(opening_hm);
        console.log(total_hm+"total_hm")
        setInputs(values => ({...values, ['total_hm']: total_hm})) 
    }
    setInputs(values => ({...values, [name]: event.target.value}))
  };

  // Function to handle changes in the Customer's Status dropdown
  const handleChangeCustomerStatusDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const deliveryChallan = selected_checkout?.delivery_challan || {};
    const dcQty = toQtyNumber(document.getElementById('dc_qty')?.value ?? deliveryChallan.dc_qty);
    const acceptedField = document.getElementById('accepted_qty');

    if(value === 'accepted'){
          const accepted_qty = computeAcceptedQtyFromDc(deliveryChallan, dcQty);
          const balance_qty = parseFloat((dcQty - accepted_qty).toFixed(2));
          if (acceptedField) {
            acceptedField.setAttribute('readOnly','readOnly');
            acceptedField.style.cursor = "not-allowed";
          }
          setBalanceStatus(ACCEPT_WITH_RETURN_OPTIONS)
          setDcStatus([
            { value: "", label: "choose customer dc status" },
            { value: "received_with_sign", label: "Received with Sign" },
            { value: "received_without_sign", label: "Received without Sign" },
            { value: "not_received", label: "Not Received" }
          ])
          setInputs(values => ({
            ...values,
            [name]: value,
            accepted_qty,
            balance_qty,
            ret_qty: 0,
            other_qty: 0,
            divert_to_ws: '',
            batch_no: '',
            balance_status: "nill",
          }))
          return;
        }
       
   if(value === 'cancelled')
    {
      if (acceptedField) {
        acceptedField.setAttribute('readOnly','readOnly');
        acceptedField.style.cursor = "not-allowed";
      }
      setBalanceStatus(RETURN_BALANCE_OPTIONS);
      setDcStatus([
        { value: "cancelled", label: "Cancelled" }
       ])
      setInputs(values => ({
        ...values,
        [name]: value,
        accepted_qty: 0,
        balance_qty: dcQty,
        ret_qty: dcQty,
        other_qty: 0,
        divert_to_ws: '',
        batch_no: '',
        cus_dc_status: "cancelled",
      }))
      return;
 }
    if(value === 'partial_accepted' ){
            const currentAccepted = toQtyNumber(acceptedField?.value ?? inputs.accepted_qty);
            if (acceptedField) {
              acceptedField.removeAttribute('readOnly');
              acceptedField.style.cursor = "pointer";
              acceptedField.setAttribute('max', dcQty);
            }
            const balance_qty = parseFloat((dcQty - currentAccepted).toFixed(2));
             setBalanceStatus(RETURN_BALANCE_OPTIONS)
            setDcStatus([
              { value: "", label: "choose customer dc status" },
              { value: "received_with_sign", label: "Received with Sign" },
              { value: "received_without_sign", label: "Received without Sign" },
              { value: "not_received", label: "Not Received" }
             ])
            setInputs(values => ({
              ...values,
              [name]: value,
              balance_qty,
              ret_qty: 0,
              other_qty: 0,
              divert_to_ws: '',
              batch_no: '',
            }))
            return;
            }
    setInputs(values => ({...values, [name]: event.target.value}))
  };

  const handleChangeAcceptedDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const deliveryChallan = selected_checkout?.delivery_challan || {};
    const dcQty = toQtyNumber(document.getElementById('dc_qty')?.value ?? deliveryChallan.dc_qty);
    const accepted_qty = toQtyNumber(value);
    const balance_qty = parseFloat((dcQty - accepted_qty).toFixed(2));
    setInputs(values => ({
      ...values,
      [name]: accepted_qty,
      balance_qty,
      ret_qty: needsReturnQty(values.balance_status) ? balance_qty : (values.ret_qty || 0),
    }))
   }
   
  const showCustomerDetails = () => {
    if (selected_checkout.id) {
        getCustomerMainDetails(cookies,selected_checkout.delivery_challan.work_schedule.sales_order_detail.sales_order.consignee.customer.id)
        .then(selectedCustomer => {
            showBillingPop(selectedCustomer)
        })
        }
    }

    const showSiteDetails = () => {
      if (selected_checkout.id) {
          getCustomerSiteDetails(cookies,selected_checkout.delivery_challan.work_schedule.sales_order_detail.sales_order.consignee.id)
          .then(consignee => {
            showCustomerSitePop(consignee);
          })
          }
      }

    const showDeliveryChallanDetails = () => {
      if (selected_checkout.id) {
          getDeliveryChallanDetails(cookies,selected_checkout.delivery_challan.id)
          .then(selected_DC => {
            showDeliveryChallanPop(selected_DC);
          })
          }
      }

      const applySelectedCheckout = (selectedCheckout) => {
        if (!selectedCheckout?.id) {
          return;
        }
        const plantIdFromCheckout = selectedCheckout?.delivery_challan?.work_schedule?.plant?.id;
        setSelectedCheckout(selectedCheckout);
        setInputs((values) => ({
          ...values,
          checkout_no: selectedCheckout.id,
          plant_id: plantIdFromCheckout || values.plant_id,
          weighment_slip_no: selectedCheckout.weighment_slip_no,
          weighment_slip_date: getDisplayDate(selectedCheckout.weighment_slip_date),
          checkout_date: getDisplayDate(selectedCheckout.checkout_date),
          weighment_slip_time: selectedCheckout.weighment_slip_time,
          gross_weight: selectedCheckout.gross_weight,
          tare_weight: selectedCheckout.tare_weight,
          net_weight: selectedCheckout.net_weight,
        }));
      };

      const handleChangeCheckOutDetails = (value) => {
        const checkoutId = value;
        if (checkoutId) {
          setIsLoading(true);
          getCheckOutDetails(cookies, checkoutId)
            .then((checkout) => {
              applySelectedCheckout(checkout);
              setIsLoading(false);
              setShowModal(false);
            })
            .catch((error) => {
              setIsLoading(false);
              displayError(error?.response?.data ?? error?.message, ' Failed');
            });
          return;
        }
        setSelectedCheckout({});
        setInputs((values) => ({
          ...values,
          checkout_no: checkoutId,
          weighment_slip_no: '',
          weighment_slip_date: getCurrentDate(),
          checkout_date: getCurrentDate(),
          weighment_slip_time: getCurrentTime(),
          gross_weight: 0,
          tare_weight: 0,
          net_weight: 0,
        }));
        setShowModal(false);
      };

      React.useEffect(() => {
        const checkoutId = searchParams.get('checkout_id');
        if (!checkoutId) {
          return;
        }
        setIsLoading(true);
        getCheckOutDetails(cookies, checkoutId)
          .then((checkout) => {
            applySelectedCheckout(checkout);
            const plantId = checkout?.delivery_challan?.work_schedule?.plant?.id;
            if (plantId) {
              return getPendingCheckInList(cookies, plantId).then((result) => {
                applyCheckoutList(result);
                setPendingCount((result?.checkout_list || []).length);
              });
            }
          })
          .catch((error) => {
            displayError(error?.response?.data ?? error?.message, ' Failed');
          })
          .finally(() => {
            setIsLoading(false);
          });
      }, [cookies, searchParams]); 
       
      const constructFormData = () => {
        const deliveryChallan = selected_checkout?.delivery_challan || {};
        const dcQty = toQtyNumber(deliveryChallan.dc_qty);
        let acceptedQty = toQtyNumber(inputs.accepted_qty);
        let balanceQty = toQtyNumber(inputs.balance_qty);
        if (inputs.customer_status === 'accepted' && !(acceptedQty > 0) && dcQty > 0) {
          acceptedQty = computeAcceptedQtyFromDc(deliveryChallan, dcQty);
          balanceQty = parseFloat((dcQty - acceptedQty).toFixed(2));
        }
        return {
            id:inputs.checkout_no,
            weighment_slip_no:inputs.weighment_slip_no,
            weighment_slip_date:getDisplayDate(inputs.weighment_slip_date),
            weighment_slip_time:inputs.weighment_slip_time,
            gross_weight:inputs.gross_weight?parseInt(inputs.gross_weight):0,
            tare_weight:inputs.tare_weight?parseInt(inputs.tare_weight):0,
            net_weight:inputs.net_weight?parseInt(inputs.net_weight):0,
            ending_km:inputs.ending_km?parseInt(inputs.ending_km):0,
            total_km:inputs.total_km?parseInt(inputs.total_km):0,
            ending_hm:inputs.ending_hm?parseInt(inputs.ending_hm):0,
            total_hm:inputs.total_hm?parseInt(inputs.total_hm):0,
            customer_status:inputs.customer_status,
            accepted_qty:acceptedQty,
            balance_qty:balanceQty,
            balance_status:inputs.balance_status,
            cus_dc_status:inputs.cus_dc_status,
            ret_qty: parseFloat(inputs.ret_qty || 0),
            other_qty: parseFloat(inputs.other_qty || 0),
            divert_to_ws: inputs.divert_to_ws || null,
            divert_batch_no: needsDivert(inputs.balance_status) ? parseInt(inputs.batch_no || 0, 10) : 0,
           }
      } 
        
  const handleSubmit = (event) => {
    event.preventDefault()
    try{
  if ((Object.values(error).every(x => !x)) && isSubmitting) {
      if (needsDivert(inputs.balance_status) && !inputs.divert_to_ws) {
        Swal.fire('Divert Work Schedule is required when Balance Status is Divert.', '', 'warning');
        return;
      }
      if (needsDivert(inputs.balance_status) && !(parseInt(inputs.batch_no || 0, 10) > 0)) {
        Swal.fire('Batch No is required when Balance Status is Divert.', '', 'warning');
        return;
      }
      if (needsReturnQty(inputs.balance_status) && !(parseFloat(inputs.ret_qty) > 0)) {
        Swal.fire('Return Qty must be greater than zero.', '', 'warning');
        return;
      }
      const divertNote = needsDivert(inputs.balance_status)
        ? ` Divert ${parseFloat(inputs.ret_qty || 0) + parseFloat(inputs.other_qty || 0)} m3 to selected Work Schedule.`
        : '';
      Swal.fire({title: (inputs.customer_status === 'cancelled'? 'This Will be Deleted if this Cancelled DC is last?. ' : '') + 'Do you want to save?' + divertNote, 
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
            if (result.isConfirmed) 
            { 
                setIsLoading(true);
                createCheckIn(cookies, constructFormData())
                .then(function (response) {
                    setIsLoading(false);
                    const divertNo = response?.data?.divert_dc_no;
                    if (divertNo) {
                      Swal.fire('Saved!', `Divert DC No: ${divertNo}`, 'success').then(() => {
                        goToCheckInMainForm(navigate, location, returnTo);
                      });
                    } else {
                      Swal.fire('Saved!', '', 'success').then(() => {
                        goToCheckInMainForm(navigate, location, returnTo);
                      });
                    }
                })
                .catch((error) =>
                {
                    setIsLoading(false);
                  console.log(error.response.data);
                  displayError(error.response.data,"Save Failed");
                })
            }
              else if (result.isDismissed) 
                {    
                Swal.fire('Not saved', '', 'info')  
                }
        });
    }
}
 catch (e) {
        displayErrorToast(e);
    }
}
       
  const Reload = () => {
  window.location.reload();
}  

const Cancel = () => {
  setInputs(() => "")
}

  const view = () => {
    navigateAfterFormSave(navigate, location, '/CheckInTable', searchParams);
  } 
  
  const Back = () => {
    if (returnTo) {
      navigate(returnTo, { replace: true });
      return;
    }
    navigate('/Home')
  }

  const Help = () => {
              setShowModal(true)
}

  const pendingCheckInCard = useMemo(
    () => buildGradientCard('Pending Check-In', pendingCount, 'today'),
    [pendingCount]
  );
  const columns = useMemo(() => PENDING_CHECKIN_LIST_COLUMNS, []);
    const Close = () => {
      setShowModal(false)
    }
    const openWeighmentModal = () => setShowWeighmentModal(true);
    const closeWeighmentModal = () => setShowWeighmentModal(false);

    useEffect(() => {
      if (!showWeighmentModal || typeof document === 'undefined') return undefined;
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previousOverflow;
      };
    }, [showWeighmentModal]);

    const DeliveryChallan = () => {
      navigate('/DeliveryChallan')
    } 
  
return (
        <>
 <div id="outer-container" className="App" >
 <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
 <ErrorToast/>
 <LoadingOverlay inProgress={inProgress}/>
 <div id="page-wrap">
 <form onSubmit={handleSubmit} >
 <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="GATE"
                title="Vehicle Check In"
                subtitle="Record vehicle arrival and delivery challan check-in details."
                modeLabel="MAIN MODE"
                headerActions={
                  <GradientCard
                    card={pendingCheckInCard}
                    onClick={() => setShowPendingCheckInList(true)}
                  />
                }
              />
            </div>
            <PendingCheckInListModal
              open={showPendingCheckInList}
              onClose={() => setShowPendingCheckInList(false)}
              cookies={cookies}
              plantId={inputs.plant_id}
              onSelect={(checkoutId) => {
                setShowPendingCheckInList(false);
                handleChangeCheckOutDetails(checkoutId);
              }}
            />

            <FloatingControls tableLink="/CheckInTable" onCancel={Cancel} enableCancel={true}/>

   <div className="form-content-wrap">
   <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3  form-control-panel">
   <Row className="form-equal-height-row no-gutters"> 
           <Col xl={6} lg={6} md={6}> 
           <div className="form-row p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill">   
           <label htmlFor="plant_id" className="form-group col-sm-5 text-right"> Plant Location </label>
               <select id="plant_id"name="plant_id" className="form-control col-sm-6  browser-default custom-select  mandatory-form-control"  required onChange={handleChangePlant} value={inputs.plant_id || ""}>
               <option value="">Select Plant</option>
                           {plants.map((item) => (
                       <option key={item.value} value={item.value}>
                           {item.label}</option>
                   ))}
               </select>
               <label htmlFor="checkout_no" className="form-group col-sm-5 text-right">Check Out No.</label>
              <div className="col-sm-6 px-0 form-input-with-icon">
              <select id="checkout_no" name="checkout_no" disabled={true}  className="form-control"   value={inputs.checkout_no || ""}>
              {/* browser-default custom-select  mandatory-form-control required onChange={handleChangeCheckOutDetails}*/}
                 <option value=""></option>
                 {checkouts.map((item) => (
                         <option key={item.value} value={item.value}>
                         {(item.label)}
                         </option>
                     ))}
               </select>
               <QuestionIcon onClickHandler={Help}/>
               </div>
                 
                <label htmlFor="checkout_date" className="form-group col-sm-5 text-right">Date & Time</label>
                <div className="col-sm-6 px-0 form-datetime-pair">
                <input type="date" className="form-control text-right" name="checkout_date" value={inputs.checkout_date || ""} id="checkout_date" readOnly={true} style={{cursor: "not-allowed"}} />
                <input type="time" id="checkout_time"  name="checkout_time"  value={selected_checkout.checkout_time || ""} className="form-control" readOnly={true} style={{cursor: "not-allowed"}}/>
                </div>

                <ViewOnlyTextbox 
                name="vehicle_no" 
                value={selected_checkout?.delivery_challan?.vehicle?.name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Vehicle No"
                inputClassName="form-control col-sm-6"
                />  
               
                <ViewOnlyTextbox 
                name="delivery_challan_no" 
                value={(selected_checkout.id ? '('+selected_checkout?.delivery_challan?.prefix +')'+selected_checkout?.delivery_challan?.delivery_challan_no : "")}
                labelClassName="form-group col-sm-5 text-right"
                label="DC No"
                inputClassName="form-control col-sm-6"
                showSummaryDetails={showDeliveryChallanDetails}
                />    
              
             <label htmlFor="checkin_date" className="form-group col-sm-5 text-right">Date & Time</label>
              <div className="col-sm-6 px-0 form-datetime-pair">
              <input type="date" className="form-control" name="checkin_date" value={inputs.checkin_date || ""} id="checkin_date" readOnly={true} style={{ cursor: "not-allowed"}} />
              <input type="time" id="checkin_time"  name="checkin_time"  value={inputs.checkin_time || ""}  readOnly={true}  style={{ cursor: "not-allowed"}} className="form-control"/>
              </div>
                           </div>
               </Col>
          
           <Col xl={6} lg={6} md={6}> 
           <div className="form-row p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill"> 
               <ViewOnlyTextbox 
                name="billing_name" 
                value={selected_checkout?.delivery_challan?.work_schedule?.sales_order_detail?.sales_order?.consignee?.customer?.name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Billing Name"
                inputClassName="form-control col-sm-6"
                showSummaryDetails={showCustomerDetails}
                />    
              
                <ViewOnlyTextbox 
                name="project_name" 
                value={selected_checkout?.delivery_challan?.work_schedule?.sales_order_detail?.sales_order?.consignee?.project_name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Project/Site Name"
                inputClassName="form-control col-sm-6"
                showSummaryDetails={showSiteDetails}
                />  
               <ViewOnlyTextbox 
                name="grade" 
                value={selected_checkout?.delivery_challan?.work_schedule?.sales_order_detail?.product?.name || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="Grade"
                inputClassName="form-control col-sm-6"
                />  

                <ViewOnlyTextbox 
                name="dc_qty" 
                value={selected_checkout?.delivery_challan?.dc_qty || ""}
                labelClassName="form-group col-sm-5 text-right"
                label="DC Qty"
                inputClassName="form-control col-sm-6"
                />

                <label htmlFor="weighment_details" className="form-group col-sm-5 text-right">Weighment Details</label>
                <div className="col-sm-6 px-0 form-input-with-icon">
                <EditSharpIcon
                  htmlColor="#1565c0"
                  onClick={openWeighmentModal}
                  sx={{ cursor: 'pointer' }}
                />
                </div>
               </div>
           </Col>
           </Row>
               <div className="modal" tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                    <div className="modal-dialog modal-xl" style={{height: "500px"}} >
                    <div className="modal-content">
                        <div className="modal-body display">
                        <div className="container item-list-table-container">
                                    <ReactTablePopUpSubmitWrapper
                                        title='List of Group Form'
                                        columns={columns}
                                        data={data.records}
                                        onRowSubmit={handleChangeCheckOutDetails}
                                        onClose = {Close}
                                        isLoading={isLoading}
                                    />
                            </div> 
                        </div>
                    </div>
                    </div>
                  </div>
</div>

<Row className="form-equal-height-row no-gutters">
<Col xl={12} lg={12} md={12}>
   <Row className="no-gutters">
   <Col xl={3} lg={3} md={6} className="pr-1">
   <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill form-panel-stack" >
              <div className="form-stack-field">
                <label htmlFor="opening_km" className="form-group mb-0">Opening KM</label>
                <input type="number" className="form-control" id="opening_km" name="opening_km" value={selected_checkout?.opening_km || 0} readOnly={true} style={{ cursor: "not-allowed" }} />
              </div>
              <div className="form-stack-field">
                <label htmlFor="ending_km" className="form-group mb-0">Ending KM</label>
                <input type="number" className="form-control" id="ending_km" name="ending_km" onChange={handleChangeOpeningKmDetails} value={inputs.ending_km || 0} />
              </div>
              <div className="form-stack-field">
                <label htmlFor="total_km" className="form-group mb-0">Total KM</label>
                <input type="number" className="form-control" readOnly={true} id="total_km" name="total_km" value={inputs.total_km || 0} style={{ cursor: "not-allowed" }} />
              </div>
           </div>
   </Col>
   <Col xl={3} lg={3} md={6} className="pl-1 pr-1">
           <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill form-panel-stack" >
             <div className="form-stack-field">
               <label htmlFor="opening_hm" className="form-group mb-0">Opening HM</label>
               <input type="number" id="opening_hm" name="opening_hm" className="form-control" value={selected_checkout?.opening_hm || 0} readOnly={true} style={{cursor:"not-allowed"}}/>
             </div>
             <div className="form-stack-field">
               <label htmlFor="ending_hm" className="form-group mb-0">Ending HM</label>
               <input type="number" className="form-control" name="ending_hm" id="ending_hm" onChange={handleChangeOpeningHmDetails} value={inputs.ending_hm || 0} />
             </div>
             <div className="form-stack-field">
               <label htmlFor="total_hm" className="form-group mb-0">Total HM</label>
               <input type="number" className="form-control" id="total_hm" name="total_hm" readOnly={true} value={inputs.total_hm || 0} style={{ cursor: "not-allowed" }} />
             </div>
             </div>
   </Col>
   <Col xl={6} lg={6} md={12} className="pl-1">
   <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill" >
             <label htmlFor="customer_status" className="form-group col-sm-4 text-right">Customer's Status</label>
              <select id="customer_status" name="customer_status" className="form-control col-sm-7  browser-default custom-select mandatory-form-control" required onChange={handleChangeCustomerStatusDetails} value={inputs.customer_status || ""}>
                 <option value="">Select</option>
                       <option value="accepted">Accepted</option>
                       <option value="partial_accepted">Partial Accepted</option>
                       <option value="cancelled">Cancelled</option>
               </select><br />

               <label htmlFor="accepted_qty" className="form-group col-sm-4 text-right">Accepted Qty</label>
               <input type="number" step="any" min="0" className="form-control col-sm-7 mandatory-form-control" required id="accepted_qty" name="accepted_qty" onChange={handleChangeAcceptedDetails} value={inputs.accepted_qty ?? 0 } readOnly={inputs.customer_status === "accepted" || inputs.customer_status === "cancelled"} style={{ cursor: (inputs.customer_status === "accepted" || inputs.customer_status === "cancelled") ? "not-allowed" : "pointer" }} /><br />
             
             <label htmlFor="balance_qty" className="form-group col-sm-4 text-right">Balance Qty</label>
               <input type="number" className="form-control col-sm-7" id="balance_qty" name="balance_qty" value={inputs.balance_qty || 0 }readOnly={true} style={{ cursor: "not-allowed" }} /><br />

             <label htmlFor="balance_status" className="form-group col-sm-4 text-right">Balance Status</label>
               <select id="balance_status" name="balance_status" className="form-control col-sm-7  browser-default custom-select mandatory-form-control" required onChange={handleChange} value={inputs.balance_status || ""}>
                 {balancestatus.map((item) => (
                         <option key={item.value} value={item.value}>
                         {(item.label)}
                         </option>
                     ))}
               </select><br />

               {needsReturnQty(inputs.balance_status) && (
                 <>
                   <label htmlFor="ret_qty" className="form-group col-sm-4 text-right">Return Qty (m3)</label>
                   <input type="number" step="0.01" min="0" className="form-control col-sm-7 mandatory-form-control" required id="ret_qty" name="ret_qty" onChange={handleChange} value={inputs.ret_qty ?? 0} /><br />
                 </>
               )}

               {needsDivert(inputs.balance_status) && (
                 <>
                   <label htmlFor="other_qty" className="form-group col-sm-4 text-right">Additional Qty (top-up)</label>
                   <input type="number" step="0.01" min="0" className="form-control col-sm-7" id="other_qty" name="other_qty" onChange={handleChange} value={inputs.other_qty ?? 0} /><br />

                   <label htmlFor="divert_to_ws" className="form-group col-sm-4 text-right">Divert Work Schedule</label>
                   <select id="divert_to_ws" name="divert_to_ws" className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChange} onFocus={() => loadDivertSchedules(
                     selected_checkout?.delivery_challan?.work_schedule?.plant?.id,
                     true
                   )} value={inputs.divert_to_ws || ""}>
                     <option value="">Select Work Schedule</option>
                     {divertSchedules.map((item) => (
                       <option key={item.value} value={item.value}>{item.label}</option>
                     ))}
                   </select><br />

                   <label htmlFor="batch_no" className="form-group col-sm-4 text-right">Batch No</label>
                   <input type="number" min="1" className="form-control col-sm-7 mandatory-form-control" required id="batch_no" name="batch_no" onChange={handleChange} value={inputs.batch_no || ""} /><br />
                 </>
               )}

               <label htmlFor="cus_dc_status" className="form-group col-sm-4 text-right">DC Status</label>
               <select id="cus_dc_status" name="cus_dc_status" className="form-control col-sm-7  browser-default custom-select mandatory-form-control" required onChange={handleChange}  value={inputs.cus_dc_status || ""}>
               {dcstatus.map((item) => (
                         <option key={item.value} value={item.value}>
                         {(item.label)}
                         </option>
                     ))}
               </select><br/>
           </div></Col>
   </Row>
</Col>
</Row>

</div>
              <div className="footer text-center">
                <Button  type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Save</Button> &nbsp;&nbsp;
                <Button type="reset" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} onClick={Cancel}>Reset</Button> &nbsp;&nbsp;
                <Button className="btn btn-twitter"  type="button"style={{width: returnToDeliveryChallan ? '180px' : '80px',fontWeight:"bold"}} onClick={view}>{returnToDeliveryChallan ? 'Back to DC' : 'View'}</Button>&nbsp;&nbsp;
                <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>{returnTo ? 'Back' : 'Home'}</Button>
                &nbsp;&nbsp;
                <Button className="btn btn-twitter"  type="button"style={{width:"100px",fontWeight:"bold"}} onClick={DeliveryChallan}>DC</Button>
              </div>
    </form>
    </div>
 </div>
      {showWeighmentModal && typeof document !== 'undefined' && createPortal(
        <div
          className="modal weighment-details-modal show"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          onClick={closeWeighmentModal}
        >
          <div
            className="modal-dialog weighment-details-modal-dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="modal-content">
              <div className="weighment-details-modal-header">
                <h5><b>Weighment Details</b></h5>
                <button type="button" className="weighment-details-close-btn" aria-label="Close" onClick={closeWeighmentModal}>×</button>
              </div>
              <div className="modal-body display">
                <div className="form-row table-bordered shadow p-2 my-1 border-secondary form-control-panel">
                  <label htmlFor="weighment_slip_no" className="form-group col-sm-4 text-right">Weighment Slip No.</label>
                  <input type="text" id="weighment_slip_no" name="weighment_slip_no" onChange={handleChange} value={inputs.weighment_slip_no || ""} className="form-control col-sm-7"/>

                  <label htmlFor="weighment_slip_date" className="form-group col-sm-4 text-right">Date & Time</label>
                  <input type="date" className="form-control col-sm-3" name="weighment_slip_date" value={inputs.weighment_slip_date || ""} id="weighment_slip_date" onChange={handleChange} />
                  <input type="time" id="weighment_slip_time" name="weighment_slip_time" onChange={handleChange} value={inputs.weighment_slip_time || ""} className="form-control col-sm-4"/>

                  <label htmlFor="gross_weight" className="form-group col-sm-4 text-right">Gross Weight</label>
                  <input type="number" id="gross_weight" name="gross_weight" onChange={handleChange} value={inputs.gross_weight || 0} className="form-control col-sm-7"/>

                  <label htmlFor="tare_weight" className="form-group col-sm-4 text-right">Tare Weight</label>
                  <input type="number" name="tare_weight" id="tare_weight" onChange={handleChange} value={inputs.tare_weight || 0} className="form-control col-sm-7"/>

                  <label htmlFor="net_weight" className="form-group col-sm-4 text-right">Net Weight</label>
                  <input type="number" id="net_weight" name="net_weight" readOnly style={{ backgroundColor: "white", cursor: "not-allowed" }} value={inputs.net_weight || 0} className="form-control col-sm-7"/>
                </div>
              </div>
              <div className="text-center weighment-details-modal-footer">
                <button type="button" className="btn btn-primary" onClick={closeWeighmentModal}>Close</button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
</>
);
}
export default CheckIn;